var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNpBellHop467975000000(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m7.5586 83.219h84.879c1.4141 0 2.5586 1.4141 2.5586 2.5586v2c0 1.4141-1.1445 2.5586-2.5586 2.5586h-84.879c-1.4141 0-2.5586-1.4141-2.5586-2.5586v-2c0-1.4141 1.1445-2.5586 2.5586-2.5586z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 65.609c0-16.289 15.711-34.211 35-34.211s34.762 17.922 34.762 34.211"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.969 9.4102h3.5312v10.109h-3.5312z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.961 24.078h5.1406c0.93359 0 1.6914 0.93359 1.6914 1.6914v0.28125c0 0.93359-0.75781 1.6914-1.6914 1.6914h-5.1406c-0.93359 0-1.6914-0.93359-1.6914-1.6914v-0.28125c0-0.93359 0.75781-1.6914 1.6914-1.6914z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.078 24.512l3.2461-1.875 5.6562 9.793-3.2461 1.875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.316 23.152l3.2461 1.875-5.5234 9.5703-3.2461-1.875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.129 24.078h3.1992v8.6797h-3.1992z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.75 67.281h35.25v14h-42.5v-5.3828s7.25 1.9102 7.25-8.6172z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.75 67.289h-35.25v14h42.5v-5.3789s-7.25 1.9102-7.25-8.6211z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpBellHop467975000000);
export default __webpack_public_path__ + "static/media/np_bell-hop_467975_000000.dbe246ae54a1237e9561c7cc571418ca.svg";
export { ForwardRef as ReactComponent };